import { useMemo } from 'react';

import { Fieldset } from 'primereact/fieldset';
import { InputText } from 'primereact/inputtext';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CalendarWrapper as Calendar } from '@/components/common/calendar-wrapper';
import { FormField } from '@/pages/embryo-details/components/FormField';
import { EmbryoDetailDto } from '@/services/embryo-service';

import { EmbryoFormFieldConfig } from './field-config';

type EmbryoQCTabProps = {
  control: Control<EmbryoDetailDto>;
  isBulkMode: boolean;
  columns?: number;
};

export function EmbryoQCTab({ control, columns = 3 }: EmbryoQCTabProps) {
  const { t } = useTranslation();

  const fieldConfigs: EmbryoFormFieldConfig[] = useMemo(
    () => [
      {
        name: 'qcEg10',
        label: t('qc.qcEg10Percent'),
        component: InputText,
      },
      {
        name: 'qcEg10Date',
        label: t('qc.qcEg10PercentDate'),
        component: Calendar,
        componentProps: { dateFormat: 'mm/dd/yy' },
      },
      {
        name: 'qcEmbHolding',
        label: t('qc.qcEmbHolding'),
        component: InputText,
      },
      {
        name: 'qcEmbHoldingExpDate',
        label: t('qc.qcEmbHoldingExpDate'),
        component: Calendar,
        componentProps: { dateFormat: 'mm/dd/yy' },
      },
      {
        name: 'qcTryPsInDate',
        label: t('qc.qcTrypsinDate'),
        component: Calendar,
        componentProps: { dateFormat: 'mm/dd/yy' },
      },
      {
        name: 'qcSucroseDate',
        label: t('qc.qcSucroseDate'),
        component: Calendar,
        componentProps: { dateFormat: 'mm/dd/yy' },
      },
      {
        name: 'qcehmDate',
        label: t('qc.ehmDate'),
        component: Calendar,
        componentProps: { dateFormat: 'mm/dd/yy' },
      },
      {
        name: 'qcfreezingComment',
        label: t('qc.qcFreezingComment'),
        component: InputText,
      },
      {
        name: 'qcStrawLotNumber',
        label: t('qc.qcStrawLotNumber'),
        component: InputText,
      },
      {
        name: 'qcVitStrawLotNumber',
        label: t('qc.qcVitStrawLotNumber'),
        component: InputText,
      },
      {
        name: 'qc12WellPlates',
        label: t('qc.twelveWellLotNumber'),
        component: InputText,
      },
    ],
    [t],
  );

  return (
    <div className="freezing-qc-tab">
      <Fieldset
        pt={{
          root: { className: 'p-2' },
          content: { className: 'space-y-2' },
        }}
      >
        <div
            className="grid gap-x-6 gap-y-1"
            style={{
              gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
            }}
          >
            {fieldConfigs.map((field) => (
              <FormField
                key={field.name}
                label={field.label}
                name={field.name}
                control={control}
                component={field.component}
                disabled={false}
                componentProps={field.componentProps}
              />
            ))}
          </div>
      </Fieldset>
    </div>
  );
}
